import type { ReactElement } from 'react';

import { PlusPaywall } from 'app/shared-components/PlusPaywall';

export default function InAppBannersPaywall(): ReactElement {
  return (
    <PlusPaywall
      source="in_app_banners_paywall"
      title="Put your services on every patient's home screen"
      description="Banners sit at the top of the Healthera app home screen, the first thing your patients see when they open it. Upload up to 3 images promoting a service or a product."
      benefits={[
        'The first thing patients see when they open the app',
        'Link each banner to a web page, or to messaging',
        'Swap banners any time, up to 3 at once',
      ]}
      image={{ src: '/assets/images/plus-paywall/in-app-banners.webp' }}
    />
  );
}
